export const replaceDynamicParams = (template: string, replacements: any) => {
    return template.replace(/{([^{]+)}/g, (match, key) => {
        return replacements[key] ? replacements[key] : '';
    });
}